
import Vue from "vue";
import userService from "@/services/userService";

export default Vue.extend({
  async mounted() {
    await userService.signOut();
  },
});
